export default "__VITE_ASSET__PTANc9K2__"